"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("react-responsive-carousel/lib/styles/carousel.min.css");
const react_1 = __importDefault(require("react"));
const react_responsive_carousel_1 = require("react-responsive-carousel");
const constants_1 = __importDefault(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const CarouselNfts = ({ nfts, isWalletConnected }) => {
    if (!isWalletConnected)
        return null;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h5", { className: styles_scss_1.default.text }, constants_1.default.walletConnection.nftsAvailable(nfts.length)),
        react_1.default.createElement(react_responsive_carousel_1.Carousel, { width: 500, showThumbs: false }, nfts.map(nft => react_1.default.createElement("div", { key: nft.id },
            react_1.default.createElement("img", { src: nft.image_url.replace("ipfs://", "https://ipfs.io/ipfs/"), alt: `NFT for${nft.name}` }),
            react_1.default.createElement("p", { className: "legend" }, nft.name)))));
};
exports.default = CarouselNfts;
